import React from "react";
import { Button, Stack, styled } from "@mui/material";

const StyledStack = styled(Stack)`
  width: 100%;
  flex-direction: row;
  justify-content: center;
  gap: 1em;
`;

const EditButtons = ({
  isEditable,
  onUpdateClicked,
  onCancelClicked,
  onSaveClicked,
  ...props
}) => {
  return (
    <StyledStack
      marginTop={2}
      {...props}>
      {!isEditable ? (
        <Button
          variant="contained"
          onClick={onUpdateClicked}>
          Update
        </Button>
      ) : (
        <>
          <Button
            variant="contained"
            onClick={onCancelClicked}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            onClick={onSaveClicked}>
            Save
          </Button>
        </>
      )}
    </StyledStack>
  );
};

export default EditButtons;